import axios from "@/plugins/axios";
import orders from "./orders";

let url = "/api/console/users/points";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },

    orders,
};
